import store from '@/store'

// setup Skip Authentication Path Names;
// const skip_auth = ['signin', 'signup', 'generatePassword', 'verifyotp'];
const skip_auth = ['signin', 'generatePassword', 'verifyotp', "paylief-ess", 'unauthorized'];

const disable_nav_gaurd = false;

const tokenAvailable = () => {
  let lsToken = window.localStorage.getItem('token');
  let token = store.state.auth.token;

  if ( lsToken == '' || lsToken == null || lsToken == undefined ||
      token == '' || token == null || token == undefined ) {
          window.localStorage.removeItem('vuex');
          window.localStorage.removeItem('token');
        return false;
  } else {
    return true;
  }
};

const nav_gaurd = (to, from, next) => {
  if( disable_nav_gaurd ) {
      console.warn('[Nav Gaurd] Nav Guard Disabled! Skipping Authentication check');
      next();
      return;
  }

  if( skip_auth.includes(to.name) ) {
    next();
  }
  else {
    if(tokenAvailable()) {
      next();
    } else {
      next({path: '/signin', query: {entry_url: to.path}});
    }
  }
};

export default nav_gaurd;
